var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntertainmentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-0.054)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rec",
    width: 40,
    height: 40,
    rx: 6,
    transform: "translate(0.054)",
    fill: "#0296a6",
    opacity: 0.075
  }), /*#__PURE__*/React.createElement("g", {
    id: "Decorative_icon",
    "data-name": "Decorative icon",
    transform: "translate(10.963 10.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Placement_Area",
    "data-name": "Placement Area",
    transform: "translate(0.091 0.091)",
    fill: "red",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 18,
    height: 18,
    transform: "translate(0.091 0.091)",
    fill: "#0296a6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102756",
    "data-name": "Path 102756",
    d: "M9.329.3l2.183,5.776,6.168.292a.258.258,0,0,1,.152.459l-4.818,3.862,1.628,5.956a.258.258,0,0,1-.39.283L9.088,13.537,3.927,16.925a.258.258,0,0,1-.39-.283l1.628-5.956L.347,6.824A.258.258,0,0,1,.5,6.366l6.166-.292L8.847.3a.258.258,0,0,1,.482,0Z",
    transform: "translate(0.003 0.001)",
    fill: "#0296a6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainmentIcon);
export default __webpack_public_path__ + "static/media/entertainment_icon.3a3efb3adb01d98d92866f3fea44c1ce.svg";
export { ForwardRef as ReactComponent };